(() => {
  'use strict';
  const turkish = document.documentElement.lang.toLowerCase().startsWith('tr');
  const labels = turkish ? {
    'shopify-pc__banner__body-title': 'Çerez tercihlerinizi seçin',
    'shopify-pc__banner__btn-manage-prefs': 'Çerezleri yönet',
    'shopify-pc__banner__btn-accept': 'KABUL ET'
  } : {};
  function enhance() {
    for (const [id, value] of Object.entries(labels)) {
      const element = document.getElementById(id);
      if (element && element.textContent !== value) element.textContent = value;
    }
    const close = document.getElementById('shopify-pc__prefs__header-close');
    if (turkish && close && close.getAttribute('aria-label') !== 'Kapat') close.setAttribute('aria-label', 'Kapat');
  }
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; enhance(); });
  }).observe(document.body, {childList: true, subtree: true});
  enhance();
  const params = new URLSearchParams(window.location.search);
  if (!window.Shopify?.designMode && (params.get('cerez') === 'goster' || params.get('pb') === '0')) {
    let attempts = 0;
    const showPreview = () => {
      const banner = window.privacyBanner;
      const method = params.get('cerez') === 'goster' ? 'showBanner' : 'loadBanner';
      if (typeof banner?.[method] === 'function') {
        Promise.resolve(banner[method]()).then(enhance).catch(() => {});
      } else if (++attempts < 40) window.setTimeout(showPreview, 250);
    };
    showPreview();
  }
  document.addEventListener('click', async event => {
    const link = event.target.closest('[data-fk-cookie-manage]');
    if (!link || !window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') return;
    event.preventDefault();
    try { await window.privacyBanner.showPreferences(); enhance(); }
    catch { window.location.assign(link.href); }
  });
})();
